/* eslint-disable */
export enum VehicleEnum {
  TRUCK = 'TRUCK',
  CAR = 'CAR',
  MOTORCYCLE = 'MOTORCYCLE',
  BIKE = 'BIKE',
  WALKER = 'WALKER',
}